import { render, staticRenderFns } from "./DetailBlockConstructor.vue?vue&type=template&id=60741ec0&scoped=true"
import script from "./DetailBlockConstructor.vue?vue&type=script&lang=js"
export * from "./DetailBlockConstructor.vue?vue&type=script&lang=js"
import style0 from "./DetailBlockConstructor.vue?vue&type=style&index=0&id=60741ec0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60741ec0",
  null
  
)

export default component.exports